import { isAssetSubmittable } from "@core/utilsV2";

import { useActivityAssetsSourceQuery } from "./useActivityAssetsSourceQuery";

export type UseIsActivitySubmittableOptions = {
  courseId: string;
  activityId: string | undefined;
  attempt?: number;
  enabled?: boolean;
};

export function useIsActivitySubmittable({
  courseId,
  activityId,
  attempt,
  enabled = true,
}: UseIsActivitySubmittableOptions) {
  const { assets } = useActivityAssetsSourceQuery({
    courseId,
    activityId,
    attempt,
    enabled,
  });

  return assets?.some(isAssetSubmittable);
}
